import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ProgressSpinnerModule } from '@shared/components';
import { MyaccountSpinnerButtonComponent } from './myaccount-spinner-button.component';
import { HomefieldButtonModule } from '@homefield';

@NgModule({
	declarations: [MyaccountSpinnerButtonComponent],
	imports: [
		CommonModule,
		HomefieldButtonModule,
		ProgressSpinnerModule
	],
	exports: [MyaccountSpinnerButtonComponent]
})
export class MyaccountSpinnerButtonModule {
}
